import AssetIdList from './assetIdList'

export default AssetIdList
